import React from "react";
import { VStack, Text, Divider } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { KYDInput, KYDMultiSelect } from "src/ui";
import { KYDGenresList } from "src/Manager/Genres";
import { InstantSearch } from "react-instantsearch";
import AlgoliaMultiSelect from "src/Manager/Campaigns/Segments/CreateNewSegmentDialog/AlgoliaMultiSelect";
import { StepProps, CreateCustomAudienceFormValues } from "../types";

const BasicInfoStep: React.FC<StepProps> = ({ eventsAlgoliaConfig }) => {
  const form = useFormContext<CreateCustomAudienceFormValues>();

  return (
    <VStack spacing={6} align="stretch">
      <KYDInput
        variant="labeled"
        label="Audience Name"
        placeholder="Enter audience name"
        value={form.watch("name")}
        onChange={(e) => form.setValue("name", e.target.value)}
      />

      <Divider />

      <VStack align="stretch" spacing={4}>
        <VStack
          align="stretch"
          spacing={2}
          boxShadow={"md"}
          borderWidth={1}
          borderColor="gray.200"
          borderRadius="lg"
          p={4}
        >
          <Text fontSize="sm" fontWeight="medium" color="gray.800">
            People who've attended events in these genres:
          </Text>
          <KYDMultiSelect
            id="genre"
            placeholder="Genre"
            options={KYDGenresList.map((item) => ({
              label: item.label,
              value: item.name,
            }))}
            values={form.watch("genres")}
            onChange={(vals) => {
              form.setValue("genres", vals);
            }}
          />
        </VStack>

        {eventsAlgoliaConfig && (
          <VStack
            align="stretch"
            spacing={2}
            boxShadow={"md"}
            borderWidth={1}
            borderColor="gray.200"
            borderRadius="lg"
            p={4}
          >
            <Text fontSize="sm" fontWeight="500">
              People who've attended events with these artists in lineup:
            </Text>
            <InstantSearch
              searchClient={eventsAlgoliaConfig?.searchClient}
              indexName={eventsAlgoliaConfig?.indexName}
            >
              <AlgoliaMultiSelect
                searchKey="performers.name"
                label=""
                placeholder="Artist Lineup"
                values={form.watch("artists")}
                onChange={(vals) => {
                  form.setValue("artists", vals);
                }}
              />
            </InstantSearch>
          </VStack>
        )}
      </VStack>
    </VStack>
  );
};

export default BasicInfoStep;
